import SkillsCardA from "tm/skillsCardA";

export { SkillsCardA };

customElements.define("tm-skills-card-a", SkillsCardA.CustomElementConstructor);
